import { render, staticRenderFns } from "./GamesLeaderBoardRoute.vue?vue&type=template&id=7e30d790&scoped=true&"
import script from "./GamesLeaderBoardRoute.vue?vue&type=script&lang=js&"
export * from "./GamesLeaderBoardRoute.vue?vue&type=script&lang=js&"
import style0 from "./GamesLeaderBoardRoute.vue?vue&type=style&index=0&id=7e30d790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e30d790",
  null
  
)

export default component.exports